import * as React from 'react';
import Plot from 'react-plotly.js';
import { agwputil } from '@ktag/styleguide/dist/platform';
import { useCreateSuspender } from '@ktag/commons';
import { Suspendable } from '@ktag/commons/dist/suspend/suspenderFactory';

interface Props {
  graphUrl: string;
  height?: number;
  copyright?: string;
}

interface PlotlyData {
  data: any;
  layout: any;
}

function App({ graphUrl, height, copyright }: Props) {
  const abortController = new AbortController();
  const resource: Suspendable<PlotlyData> = useCreateSuspender(
    graphUrl,
    (key, [url]) => {
      return agwputil.authenticatedFetch(url, { signal: abortController.signal })
        .then((res) => res.json());
    },
    { abortFn: () => abortController.abort() },
    [graphUrl],
  );

  const [{ data, layout }] = resource.read();
  return (
    <div>
      <figure className="image">
        <Plot
          data={data}
          layout={{
            ...layout,
            autosize: true,
            width: undefined,
            height,
            font: {
              family: '"AGPN", Arial, sans-serif',
            },
          }}
          style={{ width: '100%', height: '100%' }}
          config={{ displaylogo: false }}
          useResizeHandler
        />
        {copyright && copyright.length ? (
          <figcaption className="image__caption">
            <div className="image__captioninner">
              {copyright}
            </div>
          </figcaption>
        ) : null}
      </figure>
    </div>
  );
}

App.defaultProps = {
  height: undefined,
  copyright: undefined,
};

export default App;
